import { Pipe, PipeTransform } from "@angular/core";
import { countryCodes } from "./country-codes.const";

@Pipe({ name: "countryName" })
export class CountryNamePipe implements PipeTransform {
  transform(param: any): number {
    return countryCodes[param];
  }
}
